import React, { useState, useEffect } from 'react'
import { FloatingLabel } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import ReactImagePickerEditor from 'react-image-picker-editor'
import { apiURL, filesURL } from 'config/globals'
import SaveButton from './SaveButton'
import axios from 'axios'

const categoryOptions = [
    { id: 'negativeFeatures', label: 'Negative features' },
    { id: 'loadBearing', label: 'Load bearing elements' },
    { id: 'nonLoadBearing', label: 'Non-load bearing elements' },
    { id: 'frameAndRoof', label: 'Frame and roof substructure' },
    { id: 'roof', label: 'Roof' },
    { id: 'doorsAndWindows', label: 'Doors and windows' },
]

const typeOptions = [
    { id: "goodCondition", label: 'Good condition' },
    { id: "deterioration", label: 'Deterioration' },
    { id: "damage", label: 'Damage' },
]

const initialMarker = {
    category: categoryOptions[0].id,
    type: typeOptions[0].id,
    title: "",
    description: "",
}

const AddMarkerModal = (props) => {
    const [marker, setMarker] = useState(initialMarker)
    const [isSaving, setIsSaving] = useState(false)

    useEffect(() => {
        if (!props.activeMark) {
            setMarker(initialMarker)
            return
        }
        setMarker(props.activeMark)
    }, [props.activeMark])

    const handleChange = (field, value) => {
        setMarker({
            ...marker,
            [field]: value
        })
    }

    const save = async () => {
        if (!marker.image || !marker.image.uri) {
            props.onSaveMarker(marker)
            return
        }

        setIsSaving(true)
        try {
            const response = await axios.post(`${apiURL}/create-file-item`, marker)

            setIsSaving(false)
            
            if (!response.data.success) {
                //setErrorMessage(response.data.error || response.data)
                return
            }

            props.onSaveMarker({...marker, image: response.data.name})
        } catch (error) {
            //setErrorMessage(JSON.stringify(error))
            setIsSaving(false)
        }
    }

    return (
        <Modal show={props.isAddMarkModalShown} onHide={props.onCloseAddMarkModal} backdrop="static" centered>
            <Modal.Header closeButton style={{backgroundColor: '#eee'}}>
                <Modal.Title>
                    {!!props.activeMark
                        ? `Mark #${props.activeMark.id}`
                        : "New Mark"
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FloatingLabel controlId="addMarkTitle" label="Title" className="mb-3">
                    <Form.Control
                        name="title"
                        value={marker.title}
                        type="text"
                        placeholder="Add a title for the mark"
                        onChange={e => handleChange(e.target.name, e.target.value)}
                    />
                </FloatingLabel>
                <FloatingLabel controlId="addMarkDescription" label="Describe its condition and changes observed" className="mb-3">
                    <Form.Control
                        name="description"
                        value={marker.description}
                        as="textarea"
                        rows={5}
                        placeholder="Add a short description for the mark"
                        onChange={e => handleChange(e.target.name, e.target.value)}
                    />
                </FloatingLabel>
                <FloatingLabel controlId="addMarkCategory" label="Category" className="mb-3">
                    <Form.Select
                        name="category"
                        value={marker.category}
                        onChange={e => handleChange(e.target.name, e.target.value)}
                    >
                        {categoryOptions.map(option => (
                            <option key={option.id} value={option.id}>
                                {option.label}
                            </option>
                        ))}
                    </Form.Select>
                </FloatingLabel>
                <FloatingLabel controlId="addMarkType" label="Type" className="mb-3">
                    <Form.Select
                        name="type"
                        value={marker.type}
                        onChange={e => handleChange(e.target.name, e.target.value)}
                    >
                        {typeOptions.map(option => (
                            <option key={option.id} value={option.id}>
                                {option.label}
                            </option>
                        ))}
                    </Form.Select>
                </FloatingLabel>
                <ReactImagePickerEditor
                    config={{
                        borderRadius: '8px',
                        language: 'en',
                        width: '466px',
                        height: '250px',
                        objectFit: 'contain',
                        compressInitial: null,
                    }}
                    imageSrcProp={marker.image
                        ? `${filesURL}/${marker.image}`
                        : null
                    }
                    imageChanged={dataUri => {
                        handleChange('image', {
                            uri: dataUri
                        })
                    }}
                />
            </Modal.Body>
            <Modal.Footer style={{backgroundColor: '#eee'}}>
                <SaveButton isSubmitting={isSaving} onClick={save} title="Save mark" />
            </Modal.Footer>
        </Modal>
    )
}

export default AddMarkerModal